import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";
import TransitionsModal from "../../components/Modal";
import { BeatLoader } from "react-spinners";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import {
  deleteApi,
  getApi,
  postApi,
  putFormDataApi,
} from "../../config/configAxios";
import Swal from "sweetalert2";
import CustomLoader from "../../components/CustomLoader";
import { config } from "../../utils/JoditConfig";
import JoditEditor from "jodit-react";
import AdminLayout from "../../layouts/adminLayout/AdminLayout";

const DevelopmentWorkContent = () => {
  const [data, setData] = useState([]);
  const [storeData, setStoreData] = useState({});
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [category, setCategory] = useState([]);

  // fetch content
  const fetchData = async () => {
    try {
      const res = await getApi(`development-work-content`);

      setData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  // fetch category
  const fetchCategory = async () => {
    try {
      const res = await getApi(`development-work-category`);

      setCategory(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchCategory();
  }, []);

  // input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setStoreData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setStoreData((prevData) => ({
      ...prevData,
      image: file,
    }));
  };

  // store
  const handleStore = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const formData = new FormData();

    formData.append(
      "development_work_category_id",
      storeData.development_work_category_id,
    );

    formData.append("title_en", storeData.title_en);

    formData.append("title_bn", storeData.title_bn);

    formData.append("content_en", storeData.content_en);

    formData.append("content_bn", storeData.content_bn);

    formData.append("image", storeData.image);

    try {
      await postApi(`development-work-content`, formData);

      setOpenStore(false);

      setStoreData({});

      fetchData();

      toast.success("Data created successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Store failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteApi(`development-work-content/${id}`);

          toast.success("Data deleted successfully!");

          fetchData();
        } catch (err) {
          toast.error(err?.response?.data?.error || "Delete failed");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The item was not deleted.", "info");
      }
    });
  };

  // edit
  const handleEdit = async (id) => {
    setOpenEdit(true);

    try {
      const res = await getApi(`development-work-content/${id}`);

      setEditData(res.data.data);

      setStoreData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };

  // update
  const handleUpdate = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const formData = new FormData();

    formData.append("id", editData.id);

    formData.append(
      "development_work_category_id",
      storeData.development_work_category_id,
    );

    formData.append("title_en", storeData.title_en);

    formData.append("title_bn", storeData.title_bn);

    formData.append("content_en", storeData.content_en);

    formData.append("content_bn", storeData.content_bn);

    if (storeData.image instanceof File) {
      formData.append("image", storeData.image);
    }

    try {
      await putFormDataApi(`development-work-content-update`, formData);

      setOpenEdit(false);

      setStoreData({});

      fetchData();

      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout title={"Development Work Content"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          {/* header */}
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">
              Development Work Content List
            </h1>

            <div>
              <button className="btn-indigo" onClick={() => setOpenStore(true)}>
                Add New
              </button>
            </div>
          </div>

          {/* table */}
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>

                  <th className="table-h">Category</th>

                  <th className="table-h">Image</th>

                  <th className="table-h">Title EN</th>

                  <th className="table-h">Action</th>
                </tr>
              </thead>

              <tbody className="table-b">
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td className="table-b">{index + 1}</td>

                    <td className="table-b">
                      {item.development_work_category?.title_en}
                    </td>

                    <td className="table-b">
                      <img
                        src={`${process.env.REACT_APP_API_FILE_URL}${item.image}`}
                        alt=""
                        className="h-14 w-20 rounded-md object-cover"
                      />
                    </td>

                    <td className="table-b">{item.title_en}</td>

                    <td className="table-b">
                      <Box display="flex">
                        <IconButton
                          className="mr-3"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Delete className="text-red-500" />
                        </IconButton>

                        <IconButton
                          className="mr-3"
                          onClick={() => handleEdit(item.id)}
                        >
                          <Icon icon={"bxs:edit"} className="text-blue-500" />
                        </IconButton>
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* store modal */}
      <TransitionsModal title={"Add"} open={openStore} setOpen={setOpenStore}>
        <form onSubmit={handleStore}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            {/* category */}
            <div className="md:col-span-2">
              <label
                htmlFor="development_work_category_id"
                className="font-semibold text-sm"
              >
                Select Development Work Category
              </label>

              <select
                id="development_work_category_id"
                name="development_work_category_id"
                onChange={handleInputChange}
                className="form-control"
                required
              >
                <option value="">Select Category</option>

                {category?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title_en}
                  </option>
                ))}
              </select>
            </div>

            {/* title en */}
            <div className="md:col-span-2">
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>

              <input
                type="text"
                id="title_en"
                name="title_en"
                onChange={handleInputChange}
                placeholder="Enter English title"
                className="form-control"
                required
              />
            </div>

            {/* title bn */}
            <div className="md:col-span-2">
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>

              <input
                type="text"
                id="title_bn"
                name="title_bn"
                onChange={handleInputChange}
                placeholder="বাংলা শিরোনাম লিখুন"
                className="form-control"
                required
              />
            </div>

            {/* image */}
            <div className="md:col-span-2">
              <label htmlFor="image" className="font-semibold text-sm block">
                Upload Image
              </label>

              <input
                type="file"
                id="image"
                name="image"
                onChange={handleFileChange}
                className="form-control"
                accept="image/*"
              />
            </div>

            {/* content en */}
            <div className="md:col-span-2">
              <label htmlFor="content_en" className="font-semibold text-sm">
                Content EN
              </label>

              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_en}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>

            {/* content bn */}
            <div className="md:col-span-2">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                Content BN
              </label>

              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_bn}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>

            {/* button */}
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>

      {/* edit modal */}
      <TransitionsModal title={"Edit"} open={openEdit} setOpen={setOpenEdit}>
        <form onSubmit={handleUpdate}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            {/* category */}
            <div className="md:col-span-2">
              <label
                htmlFor="development_work_category_id"
                className="font-semibold text-sm"
              >
                Select Development Work Category
              </label>

              <select
                id="development_work_category_id"
                name="development_work_category_id"
                onChange={handleInputChange}
                className="form-control"
                required
                value={storeData?.development_work_category_id || ""}
              >
                <option value="">Select Category</option>

                {category?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.title_en}
                  </option>
                ))}
              </select>
            </div>

            {/* title en */}
            <div className="md:col-span-2">
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>

              <input
                type="text"
                id="title_en"
                name="title_en"
                value={storeData?.title_en || ""}
                onChange={handleInputChange}
                placeholder="Enter English title"
                className="form-control"
                required
              />
            </div>

            {/* title bn */}
            <div className="md:col-span-2">
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>

              <input
                type="text"
                id="title_bn"
                name="title_bn"
                value={storeData?.title_bn || ""}
                onChange={handleInputChange}
                placeholder="বাংলা শিরোনাম লিখুন"
                className="form-control"
                required
              />
            </div>

            {/* image */}
            <div className="md:col-span-2">
              {storeData?.image && (
                <img
                  src={`${process.env.REACT_APP_API_FILE_URL}${storeData.image}`}
                  alt=""
                  className="mb-3 h-24 w-36 rounded-md object-cover"
                />
              )}

              <label htmlFor="image" className="font-semibold text-sm block">
                Upload New Image
              </label>

              <input
                type="file"
                id="image"
                name="image"
                onChange={handleFileChange}
                className="form-control"
                accept="image/*"
              />
            </div>

            {/* content en */}
            <div className="md:col-span-2">
              <label htmlFor="content_en" className="font-semibold text-sm">
                Content EN
              </label>

              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_en}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>

            {/* content bn */}
            <div className="md:col-span-2">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                Content BN
              </label>

              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content_bn}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>

            {/* button */}
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default DevelopmentWorkContent;
